import BlogBrowser from './blog-browser-redux';

export default BlogBrowser;